import React from 'react';
import PropTypes from 'prop-types';
import FoodCardCounterItem from './FoodCardCounterItem';

const FoodCardCounterList = ({ items }) => {
    return (
        <>
            {
                items.map((item, index) => {
                    return (<FoodCardCounterItem key={'fci_' + index} name={item.name} img={item.img} />);
                })
            }

        </>
    );
};

FoodCardCounterList.propTypes = {
    items: PropTypes.array
};

export default FoodCardCounterList;
